module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-100italic.f8b1df5.woff2";